import { VStack } from "@/components/ui/vstack";
import i18n from "i18n-js";
import React from 'react';
import { useSelector } from "react-redux";
import Footer from "@/components/basic/Footer";
import Header from "@/components/basic/Header";
import QRCodeView from '@/components/basic/QRCodeView';
import BackGesture from "@/containers/BackGesture";
import { switchScreen } from '@/hooks/navigate';

export default function MyQRCode({ navigation }) {
    const user = useSelector((state) => state.user)
    const server = useSelector((state) => state.server)

    const scanQRCode = () => {
        switchScreen(navigation, 'MainStack', { screen: 'ScanQRCode' })
    }

    return (
        <BackGesture navigation={navigation}>
            <Header navigation={navigation} options={{ title: i18n.t('sideNavigationDrawer.myQRCode') }} />
            <VStack className="flex-1 items-center bg-secondary-50">
                <QRCodeView data={user.id} title={user.name} text={user.mail ? user.mail : ''} className="m-10" />
                <Footer navigation={navigation} button={server.online ? { action: scanQRCode, info: 'addContact.scanCode' } : null} />
            </VStack>
        </BackGesture>
    );
}